import { atom, PrimitiveAtom } from 'jotai';

export const $NavDrawerOpen: PrimitiveAtom<boolean> = atom(false);
